import BankDepositExportPage from './BankDepositExportPage';

export default BankDepositExportPage;
